<template>
  <div class="container">
    <!--  顶部信息  -->
    <div class="header">
      <img src="@/assets/pictures/logo.png"/>
    </div>

    <img src="@/assets/pictures/bg.png"/>
    <!--  主要信息框  -->
    <div class="main">
      <div class="left" style="display: inline;float:left;">
        <img src="@/assets/pictures/bg2.png"/>
        <div class="tips">
          {{$t("tips.Login tips1")}}
          <br/><br/>
          {{$t("tips.Login tips2")}}
          <br/><br/>
          {{$t("tips.Login tips3")}}
        </div>
      </div>

      <div class="right" style="display: inline;float:left;">
        <div class="login">
          <h2 class="login_title">{{$t("title.Login Title")}}</h2>
          <div class="login_form">
            <el-form ref="form" status-icon :model="form" label-width="100px" label-position="left">
              <el-form-item :label="$t('Login and Register.Username')" prop="username" :rules="[{ required: true, message: this.$t('Login and Register.UsernameTip'), trigger: 'blur'}]">
                <el-input v-model="form.username" @change="findUser"></el-input>
              </el-form-item>
              <el-form-item :label="$t('Login and Register.Password')" prop="password" :rules="[{ required: true, message: this.$t('Login and Register.PasswordTip1'), trigger: 'blur'}]">
                <el-input type="password" v-model="form.password"></el-input>
              </el-form-item>
              <el-form-item>
                <el-switch
                    v-model="form.language"
                    active-text="中文"
                    inactive-text="English"
                    :active-value=1
                    :inactive-value=0
                    @change="ChangeLanguage">
                </el-switch>
              </el-form-item>
              <el-form-item>
                <div class="button">
                  <el-button type="primary" @click="register" plain>{{ $t("button.Register") }}</el-button>
                  <el-button v-if="isOk" type="info" @click="doLoginInfo" plain>{{ $t("button.Log in") }}</el-button>
                  <el-button v-if="!isOk" type="success" @click="doLogin" plain>{{ $t("button.Log in") }}</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "login",
  data() {
    return {
      form: {
        username:"",
        password:"",
        language:1,
      },
      isOk:true,
      infoMessage:'',
      Years: []
    }
  },
  methods: {
    ChangeLanguage(){
      if(this.$i18n.locale==='en'){
        this.$i18n.locale='cn'
        localStorage.setItem("language", 'cn');
      }
      else{
        this.$i18n.locale='en'
        localStorage.setItem("language", 'en');
      }
    },
    findUser(){
      var that=this
      request.get("/sysUser/getUserState?username="+this.form.username).then(function (res){
        if(res.data===1) {
          that.isOk = false
        }
        if (res.data === 0) {
          that.isOk = true
          if (that.$i18n.locale === 'cn') {
            that.infoMessage = "您的账号正在审核，请耐心等待！"
          } else {
            that.infoMessage = "Your account is being reviewed, please wait patiently!"
          }
        }
        if (res.data === -1) {
          that.isOk = true
          if (that.$i18n.locale === 'cn') {
            that.infoMessage = "该账号不存在，请您注册！"
          } else {
            that.infoMessage = "This account does not exist, please register!"
          }
        }
      })
    },
    doLoginInfo(){
      alert(this.infoMessage)
    },
    doLogin(){
      request.post("/doLogin",this.$qs.stringify(this.form)).then(function (res){
        if(res.data.code===1){
          this.storeUser()
          window.sessionStorage.setItem('token', res.data.token)
          this.$router.replace({name:'Home'})
        }else if(res.data.code===2){
          if (this.$i18n.locale === 'cn'){
            alert("密码错误，登陆失败！");
            this.form.username = ""
            this.form.password = ""
          }
          else{
            alert("Password error, login failed!");
            this.form.username = ""
            this.form.password = ""
          }
        }
      }.bind(this)).catch(function (err){
        if(err.response){
          console.log(err.response)
        }
      }.bind(this))
    },
    storeUser(){
      var optionsYear=[]
      var roles=[]
      var that=this
      request.get('/sysUser/currentUser').then(res => {
        window.sessionStorage.setItem('username', res.data.username)
        roles=res.data.roles
        roles.forEach(function (role){
          if(role.id===5){
            optionsYear=that.Years
          }
          if(role.id>5){
            optionsYear.push(that.Years[role.id-6])
          }
        })
        window.sessionStorage.setItem('years', JSON.stringify(optionsYear))
      }).catch(err => {
        console.log(err);
      });
    },
    register(){
      this.$router.replace({name:'register'})
    }
  },
  created() {
    request.get('/EvaIndex/getallyear').then(res => {
      this.Years = res.data.map((year, index) => ({ value: `年份${index + 1}`, label: year }));
    });

    if(this.$i18n.locale==='cn'){
      this.form.language=1
    }
    else{
      this.form.language=0
    }
  }
}
</script>
<style scoped>
.header{
  margin-top: 20px;
  margin-bottom: 10px;
}
.login_title{
  text-align: center;
  color: #505458;
}
.tips{
  background-clip: padding-box;
  margin: 20px auto;
  width: 550px;
  padding: 15px 35px 15px 35px;
}
.login{
  border-radius: 15px;
  background-clip: padding-box;
  margin: 20px auto;
  width: 550px;
  padding: 15px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
.button{
  float: right;
}
.left{
  margin-left: 30px;
  margin-top: 30px;
}
.right{
  margin-left: 30px;
  margin-top: 30px;
}
</style>